var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMinimal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1377,
    height: 1377,
    viewBox: "0 0 1377 1377",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5264 664.608H664.609V433.643L619.43 388.463L622.965 384.927L664.609 343.282V49.5264H49.5264V664.608ZM456.252 446.252V518.104H383.463V446.252H456.252ZM456.252 258.821V330.673H383.463V258.821H456.252ZM709.137 709.136H5V5H709.137V361.726L707.672 363.19L682.399 388.462L709.137 415.199V709.136Z",
    strokeWidth: 20
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1372 5V709.136H667.863V5H1372ZM712.389 664.608H983.537V446.252H1056.33V664.608H1327.47V49.5264H712.389V664.608ZM1056.33 258.821V330.673H983.537V258.821H1056.33Z",
    strokeWidth: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M709.137 667.863V1372H5V667.863H709.137ZM49.5264 1327.47H664.609V1056.33H456.252V1119.11H383.463V921.684H456.252V983.536H664.609V712.389H49.5264V1327.47Z",
    strokeWidth: 20
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1372 667.863V1372H667.863V667.863H1372ZM712.389 1327.47H983.537V1202.83H1056.33V1327.47H1327.47V712.389H1056.33V931.684H983.537V712.389H712.389V1327.47Z",
    strokeWidth: 20
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 145.7V10H145.7L10 145.7Z",
    strokeWidth: 20
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1367 145.7V10H1231.3L1367 145.7Z",
    strokeWidth: 20
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1367 145.7V10H1231.3L1367 145.7Z",
    strokeWidth: 20
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1231.3V1367H145.7L10 1231.3Z",
    strokeWidth: 20
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1367 1231.3V1367H1231.3L1367 1231.3Z",
    strokeWidth: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMinimal);
export default __webpack_public_path__ + "static/media/LOGO-minimal.9f403fb70a55b1e7e95fc84a4835ff20.svg";
export { ForwardRef as ReactComponent };